import ajax from '@/libs/api.request'

export default {
    getQiNiuToken: param => {
        return ajax.post("web/comm/getQiNiuToken", param);
    }
}
